module.exports = __webpack_public_path__ + "static/media/aguita.09b130af.jpg";